import { React, useRef } from "react";
import "./EmployerBlog.css";
import { Select, Form, Button, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Controller, Navigation } from "swiper";
import "swiper/css";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { SelectBlogsCategoriesOptions } from "../../../../constOptions/constOptions";
import { Helmet } from "react-helmet";

const BlogItems = [
    {
        blogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        blogCategory: "HR Management & Planning",
        blogHeading: "How to manage Teams When Working Remotely",
        blogTimeStamp: "1 May, 2021",
    },
    {
        blogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        blogCategory: "HR Management & Planning",
        blogHeading: "3 Strategies for Remote Workforce Onboarding",
        blogTimeStamp: "11 March, 2021",
    },
    {
        blogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        blogCategory: "Employee Retention & Benfits",
        blogHeading: "How to Encourage Mental Health During Uncertain Work Conditions",
        blogTimeStamp: "17 March, 2021",
    },
    {
        blogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        blogCategory: "HR Management & Planning",
        blogHeading: "How to manage Teams When Working Remotely",
        blogTimeStamp: "1 May, 2021",
    },
    {
        blogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        blogCategory: "HR Management & Planning",
        blogHeading: "How to manage Teams When Working Remotely",
        blogTimeStamp: "1 May, 2021",
    },
]

const RecentBlogItems = [
    {
        recentBlogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        recentBlogCategory: "How To Use Metropolis",
        recentBlogHeading: "4 Best Practices for Analysing Reviews on Metropolis",
        recentBlogTimeStamp: "6 May, 2021",
    },
    {
        recentBlogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        recentBlogCategory: "Manage Your Brand",
        recentBlogHeading: "Metropolis Annouces Awards Criteria for the Best Place to Work 2022",
        recentBlogTimeStamp: "5 August, 2021",
    },
    {
        recentBlogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        recentBlogCategory: "How To Use Metropolis",
        recentBlogHeading: "4 Best Practices for Analysing Reviews on Metropolis",
        recentBlogTimeStamp: "6 May, 2021",
    },
    {
        recentBlogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        recentBlogCategory: "Employee Engagement",
        recentBlogHeading: "3 Quick Wins for Establishing a Culture of Employee Engagement",
        recentBlogTimeStamp: "4 May, 2021",
    },
    {
        recentBlogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        recentBlogCategory: "Hiring & Recruiting",
        recentBlogHeading: "10 Interview Questions for Sales Managers",
        recentBlogTimeStamp: "4 May, 2021",
    },
    {
        recentBlogCoverImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        recentBlogCategory: "HR Management & Planning",
        recentBlogHeading: "How to Manage Teams When Working Remotely",
        recentBlogTimeStamp: "1 May, 2021",
    },
]

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

export const EmployerBlog = () => {
    const swiperRef = useRef();
    return (
        <>
            <Helmet>
                <title>Employer Blog | Metropolis</title>
            </Helmet>

            {/* // _BEGIN > SECTION - CLAIM EMPLOYER PROFILE < SHB // */}
            <section className="sector-sign-up-banner sector-emp-blog-banner">
				<div className="mtp-container-fluid">
					<div className="section-header-xl ">
						<p className="section-header-xl-secondary-text text-color-white fw-500">
                        Employer Blog
						</p>
						<h2 className="section-header-xl-primary-heading text-color-white fw-700 ">
                        Get the latest trends and tips for recruiting, retention and branding.
						</h2>
					</div>
				</div>
			</section>
            {/* // _ENDS > SECTION - CLAIM EMPLOYER PROFILE < SHB // */}
            <section className="sector-emp-blogs">
                <div className="mtp-container">
                    <div className="sector-emp-blogs-container">
                        <div className="sector-emp-blogs-header-section">
                            <div className="sector-emp-blogs-header-section-wrap">
                                <Form layout="vertical" autoComplete="off" className="flex-center justify-space-between" initialValues={{ remember: true, }}>
                                    <div className="emp-blogs-form-wrap">
                                        <Form.Item>
                                            <Select className="mtp-select-control" placeholder="Categories" defaultValue="Categories" onChange={handleChange} options={SelectBlogsCategoriesOptions} />
                                        </Form.Item>
                                    </div>
                                    <div className="emp-blogs-form-wrap">
                                        <Form.Item className="mb-0 text-center">
                                            <Button className="ant-btn ant-btn-default mtp-button button-alpha" htmlType="submit"> Subscribe to Newsletter </Button>
                                        </Form.Item>
                                    </div>
                                    <div className="emp-blogs-form-wrap">
                                        <Form.Item className="search">                                            
                                            <SearchOutlined />                                                                                       
                                            <Input placeholder="Search" className="mtp-form-control" />
                                        </Form.Item>
                                    </div>
                                </Form>
                                {/* <Input.Search allowClear style={{ width: '40%', }} placeholder="Search" /> */}

                            </div>
                        </div>
                        <div className="sector-emp-blogs-content-section">
                            <div className="section-emp-blogs-content-header">
                                <h6 className="fw-600">Currently Trending</h6>
                                <div className="emp-blogs-arrow">
                                    <button onClick={() => swiperRef.current?.slidePrev()} className="fw-400">Prev<LeftOutlined /></button>
                                    <button onClick={() => swiperRef.current?.slideNext()} className="fw-400"><RightOutlined />Next</button>
                                </div>
                            </div>

                            <div className="section-emp-blogs-content-body swiper-wrap">
                            <Swiper
                                   onSwiper={(swiper) => { swiperRef.current = swiper; }}
                                   spaceBetween={16}
                                   slidesPerView={3}
                                   loop={true}
                                   speed={800}
                                   //autoplay={{   disableOnInteraction: true, }}
                                   navigation={false}
                                   modules={[Autoplay, Controller, Navigation]}
                                   className="mySwiperOne"
                                   onBeforeInit={(swiper) => {
                                    swiperRef.current = swiper;
                                  }}
                              >
                            {BlogItems.map((blogItems, blogIndex) => (                                
                                <SwiperSlide key={blogIndex} className="section-emp-blogs-content-wrap">
                                    <div className="section-emp-blogs-content-card">
                                        <div className="section-emp-blogs-content-image">
                                            <img src={blogItems.blogCoverImage} width={456} height={240} alt="blogCardImage" />
                                        </div>
                                        <div className="section-emp-blogs-content-desc">
                                            <div className="section-emp-blogs-content-desc-wrap">
                                                <div className="emp-blogs-category fw-500">{blogItems.blogCategory}</div>
                                                <div className="emp-blogs-title fw-600">{blogItems.blogHeading}</div>
                                            </div>
                                            <div className="section-emp-blogs-content-desc-wrap-se">
                                                <div className="emp-blogs-date fw-500">{blogItems.blogTimeStamp}</div>
                                                <div className="emp-blogs-btn ant-btn ant-btn-default mtp-button button-alpha">Read Now</div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>                                
                            ))}
                            </Swiper>                            
                            </div>
                        </div>
                        <div className="sector-emp-blogs-content-section">
                            <div className="section-emp-blogs-content-header">
                                <h6 className="fw-600">Recent Articles</h6>
                            </div>
                            
                            <div  className="section-emp-blogs-content-body">
                                {RecentBlogItems.map((RecentBlogItems, RecentBlogIndex) => (
                                    <div key={RecentBlogIndex} className="section-emp-blogs-content-wrap">
                                       <div className="section-emp-blogs-content-card">
                                            <div className="section-emp-blogs-content-image">
                                                <img src={RecentBlogItems.recentBlogCoverImage} width={456} height={240} alt="blogCardImage" />
                                            </div>
                                            <div className="section-emp-blogs-content-desc">
                                                <div className="section-emp-blogs-content-desc-wrap">
                                                    <div className="emp-blogs-category fw-500">{RecentBlogItems.recentBlogCategory}</div>
                                                    <div className="emp-blogs-title fw-600">{RecentBlogItems.recentBlogHeading}</div>
                                                </div>
                                                <div className="section-emp-blogs-content-desc-wrap-se">
                                                    <div className="emp-blogs-date fw-500">{RecentBlogItems.recentBlogTimeStamp}</div>
                                                    <div className="emp-blogs-btn ant-btn ant-btn-default mtp-button button-alpha">Read Now</div>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                ))}
                            </div>
                            <div className="show-more-btn">
                            <div className="emp-blogs-show-more-btn ant-btn ant-btn-default mtp-button button-alpha fw-600">Show More</div>
                            </div>  
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}